<mat-card
  class="note-banner-card"
  *ngIf="!closed"
  [@.disabled]="!animation"
  [@bounceIn]="animation"
  [ngStyle]="{
    '--background': bannerBg,
    '--text': textColor,
    '--max-height': maxHeight,
    '--margin-top': hasBreadCrumb ? '64px' : '8px',
  }"
>
  <mat-card-content>
    <div class="note-banner-row">
      <div class="note-banner-content">
        <mat-icon class="note-banner-icon">{{ noteIcon }}</mat-icon>
        <div>
          <span class="note-banner-text-wrapper">
            <span class="note-banner-title" *ngIf="noteTitle">{{ noteTitle | translate }}:</span>
            <span class="note-banner-text" [innerHTML]="noteText | translate"></span>
          </span>
        </div>
      </div>
      <button *ngIf="canClose" mat-icon-button class="note-banner-close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>
